import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import UnleashYourPotential from "./sections/UnleashYourPotential";
import TheForcePrograms from "./sections/TheForcePrograms";
import ProofOfPower from "./sections/ProofOfPower";
import ForceByTheNumbers from "./sections/ForceByTheNumbers";
import AthleteFeedback from "./sections/AthleteFeedback";
import StartYourJourney from "./sections/StartYourJourney";
import TheBasecamp from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <UnleashYourPotential />
      <TheForcePrograms />
      <ProofOfPower />
      <ForceByTheNumbers />
      <AthleteFeedback />
      <StartYourJourney />
      <TheBasecamp />
    </div>;
}